import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useIntl } from "react-intl";
import GoogleMapsButton from "../../components/GoogleMapsButton";
import Icon from "../../components/Icon";
import Widget from "../../components/Widget";
import Image from "../../overrides/venia-ui/components/Image";

// Styles
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./storeDetails.module.scss";

//Assets
import point from "../../assets/images/pickup-point.png";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import Button from "@overrides_venia/venia-ui/components/Button/button";
import { useHistory } from "@magento/venia-ui/lib/drivers";
import it from "date-fns/locale/it";
import { addDays, format, startOfWeek, isSameDay } from "date-fns";

// GMB Hours Integration
import { useGmbOpeningHours } from "@Src_main/utils/useGmbOpeningHours";
import { dateObjectToDate } from "@Src_main/utils/gmbOpeningHoursUtils";
import { isOnlineOrderStore, isOnlineOrderingClosed } from "@Src_main/utils/onlineOrdering";
import { env } from "build/env";
var StoreDetails = _ref => {
  var _store$address, _store$address2;
  var {
    store,
    showCta = true
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  var {
    isMobile
  } = useWindowSize();
  var history = useHistory();
  var classes = mergeClasses(defaultClasses);

  // Get GMB location ID from store config
  var gmbLocationId = (store === null || store === void 0 ? void 0 : store.gmbLocationId) || null;

  // Fetch GMB opening hours
  var {
    specialHours: gmbSpecialHours,
    storeStatus
  } = useGmbOpeningHours(gmbLocationId);
  var firstDOW = startOfWeek(new Date(), {
    weekStartsOn: 1
  });
  var shortWeekDaysArray = Array.from(Array(7)).map((e, i) => format(addDays(firstDOW, i), "EEEE", {
    locale: it
  }));

  // Simple open/closed check based on storeStatus
  var isOpen = storeStatus && storeStatus.isOpen !== undefined ? storeStatus.isOpen : true;

  // Get future special hours periods only
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  var specialHoursPeriods = ((gmbSpecialHours === null || gmbSpecialHours === void 0 ? void 0 : gmbSpecialHours.specialHourPeriods) || []).filter(period => {
    var endDate = period.endDate ? dateObjectToDate(period.endDate) : dateObjectToDate(period.startDate);
    return endDate >= today;
  });

  // Format date for display
  var formatSpecialDate = dateObj => {
    var date = dateObjectToDate(dateObj);
    return format(date, "d MMM", {
      locale: it
    });
  };
  var storeHoursList = Object.keys(store.store_hours).map(dow => {
    return {
      hours: _objectSpread({}, store.store_hours[dow]),
      dow: dow
    };
  }).map((x, i) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "uk-flex uk-flex-between uk-margin-xsmall-bottom",
      key: i,
      style: {
        fontSize: '14px'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: '#666',
        textTransform: 'capitalize'
      }
    }, shortWeekDaysArray[i]), /*#__PURE__*/React.createElement("div", {
      className: "uk-flex uk-flex-column",
      style: {
        textAlign: 'right'
      }
    }, Object.values(x.hours).map((interval, idx) => /*#__PURE__*/React.createElement("span", {
      key: idx,
      style: {
        color: '#333'
      }
    }, interval.open, " - ", interval.close))));
  });
  var position = (_store$address = store.address) !== null && _store$address !== void 0 && _store$address.address1 ? "Miscusi , " + store.address.address1 + "," + store.address.city + "," + store.address.post_code : "Miscusi";
  var maps = /*#__PURE__*/React.createElement("div", {
    className: "uk-margin-small-left uk-margin-small-right uk-margin-medium-top"
  }, /*#__PURE__*/React.createElement(GoogleMapsButton, {
    link: "https://maps.google.com/?q=".concat(position),
    onlyTakeaway: store.special_restaurant_closing == 1 && !isOnlineOrderingClosed(store, "TAKEAWAY")
  }));

  // Simple Status Badge
  var StatusBadge = () => /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      backgroundColor: isOpen ? '#E8F5E9' : '#FFEBEE',
      color: isOpen ? '#2E7D32' : '#C62828',
      padding: '8px 16px',
      borderRadius: '20px',
      fontSize: '14px',
      fontWeight: '600',
      marginBottom: '20px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '10px'
    }
  }, "\u25CF"), isOpen ? formatMessage({
    id: "storeHours.openNow"
  }) : formatMessage({
    id: "storeHours.closedNow"
  }));

  // Special Hours Section (simple list, no logic)
  var SpecialHoursSection = () => {
    if (specialHoursPeriods.length === 0) return null;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '16px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#E65100',
        marginBottom: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }
    }, formatMessage({
      id: "storeHours.specialHours"
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: 'rgba(230, 81, 0, 0.06)',
        borderRadius: '10px',
        padding: '12px 14px'
      }
    }, specialHoursPeriods.map((period, idx) => {
      var _period$openTime, _period$openTime2, _period$closeTime, _period$closeTime2;
      var startDate = formatSpecialDate(period.startDate);
      var endDate = period.endDate ? formatSpecialDate(period.endDate) : startDate;
      var dateRange = startDate === endDate ? startDate : "".concat(startDate, " - ").concat(endDate);
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "uk-flex uk-flex-between uk-flex-middle",
        style: {
          fontSize: '14px',
          padding: '6px 0',
          borderBottom: idx < specialHoursPeriods.length - 1 ? '1px solid rgba(0,0,0,0.06)' : 'none'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#333'
        }
      }, dateRange), /*#__PURE__*/React.createElement("span", {
        style: {
          color: period.closed ? '#C62828' : '#666',
          fontWeight: period.closed ? '600' : '400'
        }
      }, period.closed ? formatMessage({
        id: "storeHours.closed"
      }) : "".concat(String(((_period$openTime = period.openTime) === null || _period$openTime === void 0 ? void 0 : _period$openTime.hours) || 0).padStart(2, '0'), ":").concat(String(((_period$openTime2 = period.openTime) === null || _period$openTime2 === void 0 ? void 0 : _period$openTime2.minutes) || 0).padStart(2, '0'), " - ").concat(String(((_period$closeTime = period.closeTime) === null || _period$closeTime === void 0 ? void 0 : _period$closeTime.hours) || 0).padStart(2, '0'), ":").concat(String(((_period$closeTime2 = period.closeTime) === null || _period$closeTime2 === void 0 ? void 0 : _period$closeTime2.minutes) || 0).padStart(2, '0'))));
    })));
  };

  // Regular Hours Section (always open)
  var RegularHoursSection = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '10px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    }
  }, formatMessage({
    id: "storeHours.regularHours"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: 'rgba(0,0,0,0.03)',
      borderRadius: '10px',
      padding: '12px 14px'
    }
  }, storeHoursList));
  var storeHoursSection = /*#__PURE__*/React.createElement("div", {
    style: {
      padding: isMobile ? '0 16px' : '0',
      maxWidth: isMobile ? '100%' : '400px',
      margin: '0 auto',
      width: '100%',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(StatusBadge, null), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(SpecialHoursSection, null), /*#__PURE__*/React.createElement(RegularHoursSection, null)));
  var content = /*#__PURE__*/React.createElement("div", {
    className: "content ".concat(classes.content, " uk-flex uk-flex-column")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.image)
  }, /*#__PURE__*/React.createElement(Image, {
    alt: store.frontend_name,
    src: isMobile ? store.store_preview_image_mobile ? store.store_preview_image_mobile : point : store.store_preview_image_desktop ? store.store_preview_image_desktop : store.store_preview_image_mobile,
    height: "84",
    width: "auto",
    displayPlaceholder: false
  })), store.frontend_name ? /*#__PURE__*/React.createElement("h1", {
    className: "uk-text-uppercase uk-text-center store-name"
  }, store.frontend_name) : null, (_store$address2 = store.address) !== null && _store$address2 !== void 0 && _store$address2.address1 ? /*#__PURE__*/React.createElement("div", {
    className: "store-address uk-text-center",
    style: {
      marginBottom: '20px',
      color: '#666'
    }
  }, store.address.address1) : null, storeHoursSection, /*#__PURE__*/React.createElement("div", {
    className: "uk-fixed uk-margin-small uk-grid uk-grid-small uk-child-width-expand",
    style: !isMobile ? {
      maxWidth: "700px",
      marginLeft: "auto",
      marginRight: "auto"
    } : {}
  }, showCta && isOnlineOrderStore(store) && (env.store_view_code !== "miscusi_ch_sv" || !isOnlineOrderingClosed(store, "TAKEAWAY")) ? /*#__PURE__*/React.createElement(Button, {
    color: "miscusi_red",
    extraClass: "uk-box-shadow-medium uk-margin-xsmall-right",
    type: "button",
    onClick: () => {
      history.push(formatMessage({
        id: "url.key.order.from.restaurant"
      }) + "/" + store.ls_store_id);
    }
  }, formatMessage({
    id: "button.order"
  })) : null, showCta && store.isReservationActive ? /*#__PURE__*/React.createElement(Button, {
    color: "dark-green",
    extraClass: "uk-box-shadow-medium uk-margin-xsmall-left",
    type: "button",
    onClick: () => {
      history.push(formatMessage({
        id: "url.key.book.a.table.from.restaurant"
      }) + "/" + store.ls_store_id);
    }
  }, formatMessage({
    id: "button.bookatable"
  })) : null), maps, store ? store.widgets.map((widget, i) => /*#__PURE__*/React.createElement(Widget, _extends({
    key: i
  }, widget))) : null);
  return /*#__PURE__*/React.createElement("div", {
    className: "page-store-details ".concat(classes.storeDetails)
  }, content);
};
export default StoreDetails;